import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

declare global {
  interface Window {
    __HMS_REPORT_READY__?: boolean;
  }
}

/**
 * The PDF export opens the report with «?pdf=true». The report then opens every part and
 * says when it is ready, so the PDF has all of it.
 */
export const useHmsReportPdf = (ready: boolean) => {
  const [params] = useSearchParams();
  const forPdf = params.get('pdf') === 'true';
  useEffect(() => {
    if (forPdf && ready) window.__HMS_REPORT_READY__ = true;
  }, [forPdf, ready]);
  return forPdf;
};
